import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import navigationService from './navigationService';

// Hook to register the navigate function with the global navigation service
const useRegisterNavigate = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigationService.setNavigate(navigate);
    return () => navigationService.clearNavigate();
  }, [navigate]);
};

export default useRegisterNavigate;
